import { SelectFieldOption } from "components/Form/FormikControls";
import {
  RuleValueFormatByRawValueFormat,
  RuleValueFormatDisplayName,
} from "constants/ruleBooks";

export const RuleValueFormatOptionsByRawValueFormat = Object.entries(
  RuleValueFormatByRawValueFormat,
).reduce(
  (acc, [rawValueFormat, ruleValueFormats]) => {
    acc[rawValueFormat] = ruleValueFormats.map(
      (ruleValueFormat): SelectFieldOption => ({
        value: ruleValueFormat,
        label: RuleValueFormatDisplayName[ruleValueFormat],
      }),
    );
    return acc;
  },
  {} as Record<string, SelectFieldOption[]>,
);
